/**
 * Maps frontend automation schema to backend CreateTwitterAutomationInput
 * The frontend has quest properties at root level, backend expects them in questTemplate
 */
export function mapFrontendToBackend(frontendData, communityExternalAccountId) {
    return {
        name: frontendData.name,
        communityExternalAccountId,
        trigger: frontendData.trigger,
        questTemplate: {
            title: frontendData.title,
            description: frontendData.description,
            moduleId: frontendData.moduleId,
            taskType: frontendData.taskType,
            taskConfig: frontendData.taskConfig,
            rewards: frontendData.rewards,
            conditions: frontendData.conditions,
            conditionOperator: frontendData.conditionOperator,
            claimLimit: frontendData.claimLimit,
            retryAfter: frontendData.retryAfter,
            archiveAfterHours: frontendData.archiveAfterHours,
            delayHours: frontendData.delayHours,
            addToCurrentSprint: frontendData.addToCurrentSprint,
            aiReview: frontendData.aiReview ?? false,
            aiPrompt: frontendData.aiPrompt,
        },
        active: true,
    };
}
/**
 * Maps backend automation response to frontend automation schema
 * The backend has quest properties in questTemplate, frontend expects them at root level
 */
export function mapBackendToFrontend(backendData) {
    const questTemplate = backendData.questTemplate || {};
    return {
        id: backendData.id,
        active: backendData.active,
        name: backendData.name,
        trigger: backendData.trigger,
        // Flatten quest properties to root level
        title: questTemplate.title || '',
        description: questTemplate.description,
        moduleId: questTemplate.moduleId || '',
        taskType: questTemplate.taskType || 'tweetReact',
        taskConfig: questTemplate.taskConfig || {},
        rewards: questTemplate.rewards || [],
        conditions: questTemplate.conditions || [],
        conditionOperator: questTemplate.conditionOperator || 'AND',
        claimLimit: questTemplate.claimLimit || 0,
        retryAfter: questTemplate.retryAfter != null ? String(questTemplate.retryAfter) : undefined,
        archiveAfterHours: questTemplate.archiveAfterHours ?? undefined,
        delayHours: questTemplate.delayHours ?? undefined,
        addToCurrentSprint: questTemplate.addToCurrentSprint ?? true,
        aiReview: questTemplate.aiReview ?? false,
        aiPrompt: questTemplate.aiPrompt ?? null,
        // Runtime metadata from aggregated automation run data
        questsCreated: backendData.questsCreated ?? 0,
        lastTriggered: backendData.lastTriggered ? new Date(backendData.lastTriggered) : undefined,
    };
}
